module.exports = __webpack_public_path__ + "img/tagged.8455ac23.png";